module.exports = __webpack_public_path__ + "img/8f3ca38c5e678a9ed1fba98e766a3603.png";